/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { selectListingDetailsError } from '@zcode-ui/perm-address'
import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'

import { MessageForm } from './MessageForm'

export const mapStateToProps = (state: State) => {
  return {
    error: selectListingDetailsError(state),
  }
}

export const MessageFormContainer = connect(mapStateToProps)(MessageForm)
